
<router-outlet></router-outlet>
<p-confirmDialog class="-m-2" header="Confirmation" [style]="{width: '50vw'}"  [baseZIndex]="10000"></p-confirmDialog>
